import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1310d4b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "mr-4 text-xs md:text-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute right-2 w-5 h-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "w-full border-b border-line"
}
const _hoisted_5 = ["onClick"]

import {Ref, ref, computed, onMounted, watch} from "vue";
import vClickOutside from "@baiguangteng/vue3-click-outside";


import {defineComponent, PropType} from "vue";

export interface DropdownItem {
  title: string;
  data: unknown;
}

const __default__ = defineComponent({
  name: "CSDropdown",
  methods: {},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  alwaysTitle: {
    type: String,
    required: false,
  },
  title: {
    type: String,
    required: false,
  },
  items: {
    type: Object as PropType<DropdownItem[]>,
    required: true,
  },
},
  emits: ["onClick"],
  setup(__props, { emit }) {

const props = __props;





let currentItem: Ref<DropdownItem> = ref({title: "", data: null});
let isShowAni = ref(false);
let isShowDrop = ref(false);

const sTitle = computed(() => {
  console.log("lifecycle - computed setup");

  let title = "";

  if (props.alwaysTitle) {
    title = props.alwaysTitle;
  } else if (props.title) {
    title = props.title;
  } else if (currentItem && currentItem.value) {
    title = currentItem.value.title;
  }

  return title;
});

onMounted(() => {
  if (!props.alwaysTitle && props.items.length) {
    currentItem.value.title = props.items[0].title;
    currentItem.value.data = props.items[0].data;
  }
});

const onClickToggle = () => {
  isShowDrop.value = !isShowDrop.value;
  setTimeout(() => {
    isShowAni.value = !isShowAni.value;
  }, 50);
};

const onClickOutside = () => {
  if (isShowAni.value) {
    isShowAni.value = false;
    isShowDrop.value = false;
  }
};

const onClickItem = (item: DropdownItem) => {
  currentItem.value = item;

  onClickOutside();
  emit("onClick", item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "toggle-btn flex items-center w-full py-3 px-3 bg-white border border-input rounded-md",
      onClick: onClickToggle
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(sTitle.value), 1),
      _hoisted_3
    ]),
    (_unref(isShowDrop))
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["absolute left-0 w-full py-2 bg-white border border-line rounded-md shadow-xl cs-dropdown", [{active: _unref(isShowAni)}]]),
          style: {"z-index":"10"}
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              ('line' === item.data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "w-full text-left py-3 px-3",
                    onClick: _withModifiers(($event: any) => (onClickItem(item)), ["stop"])
                  }, _toDisplayString(item.title), 9, _hoisted_5))
            ]))
          }), 128))
        ], 2)), [
          [_unref(vClickOutside), onClickOutside]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})